<template>
  <footer class="footer clearfix">
    <p class="copyright float-left">{{$t('footer.app-version')}}</p>
    <img class="logo-image float-right" src="~assets/img/logo-somfy.svg" alt="Somfy logo">
  </footer>
</template>

<script>
export default {
  name: 'app-footer'
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';

  .footer {
    background-color: $grey-50;
    padding: 9px 20px;

    p.copyright {
      margin: 0;
      font-size: 11px;
      line-height: 15px;
      color: #000000;
    }

    img.logo-image {
      height: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// Footer.vue?6978a10b